module.exports = __webpack_public_path__ + "static/media/test13_4.3b32113c.png";